import { Department, useDepartmentQuery } from 'graphql-common';
import { WatchQueryFetchPolicy } from '@apollo/client';
import { SingleQueryHookResult } from 'utils/fetch/types';

type Args = {
  id?: string;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
};

export default function useDepartmentQueryHook(
  args: Args,
): SingleQueryHookResult<Department> {
  const { id = '', skip = true, fetchPolicy = 'network-only' } = args;
  const query = useDepartmentQuery({
    skip,
    variables: { id },
    fetchPolicy,
  });
  const { refetch, error, loading, data: queryData, previousData } = query;
  const data = queryData || previousData;
  const firstLoading = loading && queryData === undefined;

  return {
    data: data?.data as Department,
    loading,
    error,
    refetch,
    firstLoading,
  };
}
